import { useEffect, useState } from 'react';
import { PremiumBackground } from './PremiumBackground';
import { DesktopSplash } from './DesktopSplash';
import { useIsDesktop } from '../../hooks/useMediaQuery';

interface SplashScreenProps {
  progress?: number;
}

export function SplashScreen({ progress: externalProgress }: SplashScreenProps) {
  const isDesktop = useIsDesktop();
  const [internalProgress, setInternalProgress] = useState(0);
  const progress = externalProgress ?? internalProgress;
  const progressLabel = Math.round(progress);

  useEffect(() => {
    if (externalProgress !== undefined) return;

    const start = performance.now();
    const duration = 2200;

    const tick = (now: number) => {
      const elapsed = now - start;
      const next = Math.min(92, (elapsed / duration) * 92);
      setInternalProgress(next);
      if (elapsed < duration) requestAnimationFrame(tick);
    };

    const frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [externalProgress]);

  if (isDesktop) {
    return <DesktopSplash progress={progress} />;
  }

  return (
    <div className="cs-premium-screen cs-splash-premium">
      <PremiumBackground />

      <div className="cs-premium-screen__content cs-splash-premium__content">
          <div className="cs-splash-premium__hero">
          <div className="cs-splash-premium__globe-wrap">
            <div className="cs-splash-premium__globe-glow" />
            <img
              src="/brand/logo-128.webp"
              alt=""
              className="cs-splash-premium__globe"
              width={120}
              height={120}
              draggable={false}
            />
          </div>

          <h1 className="cs-splash-premium__title">CozzySIM</h1>
          <p className="cs-splash-premium__subtitle">Fast eSIM for Travel</p>
        </div>

        <div className="cs-splash-premium__loader">
          <div className="cs-splash-premium__loader-track">
            <div
              className="cs-splash-premium__loader-bar"
              style={{ width: `${progress}%` }}
            />
          </div>
          <span className="cs-splash-premium__loader-label">{progressLabel}%</span>
        </div>
      </div>
    </div>
  );
}
